module.exports = __webpack_public_path__ + "img/exclusive-box.88e38033.png";